import AuthService from "./api/AuthService";
import { authServiceReverb } from "./api/AuthService";
import store from "@/store";
import { materialsServiceReverb } from "./api/MaterialsApiService";
import UsersListView from "@/views/UsersListView.vue";

export const createUser = async (payload, userToken) => {
    try {
        const response = await AuthService.post('/users', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao criar usuário:', error);

        throw error;
    }
}

export const findUser = async (payload) => {
    try {
        let url = `/users/${payload?.userId}?`
        payload?.include && (url += `include=${payload?.include}&`)


        const response = await AuthService.get(url);

        return response.data;
    } catch (error) {
        console.error('Erro ao processar a requisição de usuários:', error);

        throw error;
    }
};

export const updateUser = async (payload, userToken) => {
    try {
        const response = await AuthService.put('/users/' + payload.userId, payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar informações do usuário:', error);

        throw error;
    }
}

export const deleteUser = async (userId, userToken) => {
    try {
        const response = await AuthService.delete('/users/' + userId, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao deletar usuário:', error);

        throw error;
    }
}

export const getUsers = async (payload, userToken) => {
    try {
        let url = '/users?';

        payload?.search && (url += `search=${payload.search}&`);
        payload?.role && (url += `role=${payload.role}&`);
        payload?.userResponsible && (url += `user_responsible=${payload.userResponsible}&`);
        payload?.disciplineId && (url += `discipline_id=${payload.disciplineId}&`);
        payload?.page && (url += `page=${payload.page}&`);
        payload?.tutorId && (url += `tutor_id=${payload.tutorId}&`);
        payload?.perPage && (url += `per_page=${payload.perPage}&`);
        payload?.include && (url += `include=${payload.include}&`);

        const response = await AuthService.get(url.slice(0, -1), {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao consultar usuários:', error);
        throw error;
    }
}

export const changePassword = async (payload, userToken) => {
    try {
        const response = await AuthService.post(`/users/${payload.userId}/change-password`, payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao alterar senha:', error);

        throw error;
    }
}

export const pingUser = async (userToken) => {
    try {
        await AuthService.post('/ping', null, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        })
    } catch {
        throw new Error("Ping não registrado!")
    }
}

export const createUserContacts = async (payload) => {
    try {
        const response = await AuthService.post('/contacts/create-many', payload)
        return response.data
    } catch (error) {
        throw new Error("Ocorreu um erro ao salvar contatos! Tente novamente")
    }
}

export const updateUserContacts = async (payload) => {
    try {
        const response = await AuthService.post('/contacts/update-many', payload)
        return response.data
    } catch (error) {
        throw new Error("Ocorreu um erro ao salvar contatos! Tente novamente")
    }
}

export const deleteUserContacts = async (payload) => {
    try {
        const response = await AuthService.post('/contacts/delete-many', payload)
        return response.data
    } catch (error) {
        throw new Error("Ocorreu um erro ao excluir contatos! Tente novamente")
    }
}

export const getUserContacts = async (userId) => {
    try {
        const response = await AuthService.get(`/contacts?user_id=${userId}`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao requisitar contatos do usuário!")
    }
}

export const initiliazeUserReverbConnection = (channelName, events) => {

    const authServiceLocalInstance = authServiceReverb()
    const materialsServiceLocalInstance = materialsServiceReverb()

    if (authServiceLocalInstance) {
        try {
            const privateChannel = authServiceLocalInstance.private(channelName)
            events.forEach((event) => {
                privateChannel.listen(event.eventName, (wsEvent) => {
                    const eventData = wsEvent[event.objectField]

                    event.actionRelatedToModules ?
                        store.dispatch(event.storeAction, eventData)
                        : handleCustomWSActions(event.eventName, eventData)
                })
            })
        } catch (error) {
            throw new Error("Ocorreu um erro ao conectar no canal de Achievements")
        }
    }

    if (materialsServiceLocalInstance) {
        try {
            const privateChannel = materialsServiceLocalInstance.private(channelName)
            events.forEach((event) => {
                privateChannel.listen(event.eventName, (wsEvent) => {
                    const eventData = wsEvent[event.objectField]

                    event.actionRelatedToModules ?
                        store.dispatch(event.storeAction, eventData)
                        : handleCustomWSActions(event.eventName, eventData)
                })
            })
        } catch (error) {
            throw new Error("Ocorreu um erro ao conectar no canal de Achievements")
        }
    }
}

export const updateUserAvatar = async (payload) => {
    try {
        const response = await AuthService.post(`/users/${payload.userId}/avatar`, payload.avatarData)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao atualizar o avatar do usuário! Tente novamente")
    }
}

const redirectUserToMaterialItemURL = (materialURL) => {
    materialURL && (window.open(materialURL, '_blank'))
}

const handleCustomWSActions = (eventName, eventData) => {
    if (eventName === '.watermark.created') {
        redirectUserToMaterialItemURL(eventData)
    }
}

export default {
    updateUserAvatar,
    initiliazeUserReverbConnection,
    getUserContacts,
    deleteUserContacts,
    updateUserContacts,
    createUserContacts,
    pingUser,
    createUser,
    findUser,
    updateUser,
    deleteUser,
    getUsers,
    changePassword
}